










import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import DetailCard from '@/components/molecules/DetailCard.vue'
import UseButton from '@/components/molecules/UseButton.vue'
import ConfettiModal from '@/components/organisms/ConfettiModal.vue'
import { State as benefitsState } from '@/store/modules/benefits'

export default Vue.extend({
  name: 'ItemDetail',
  components: {
    SimpleLoader,
    DetailCard,
    UseButton,
    ConfettiModal
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.benefits.isBenefitsLoading
    },
    benefit(): benefitsState['benefitDetil'] | null {
      return this.$state.benefits.benefitDetil
    },
    hasUsed(): boolean {
      return this.$state.benefits.hasUsed
    },
    buttonText(): '使用済み' | 'いますぐ使用する' {
      return this.hasUsed ? '使用済み' : 'いますぐ使用する'
    },
    buttonLabel(): '使用済み' | '現在未使用です' {
      return this.hasUsed ? '使用済み' : '現在未使用です'
    },
    usedAt(): string {
      return this.$state.tickets.usedAt
    },
    isUsedComplete(): boolean {
      return this.$state.tickets.isUsedComplete
    }
  },
  methods: {
    onUseClick() {
      if (this.benefit && this.benefit.feature === 'remote') {
        this.$router.push(`/items/${this.$route.params.id}/use`)
      } else {
        this.$store.dispatch('tickets/postTicketsUse', {
          ticket_id: this.$state.tickets.ticketId
        })
      }
    },
    transitionHome() {
      this.$router.push('/home')
    }
  },
  mounted() {
    if (this.$state.tickets.ticketId.length === 0) {
      this.$router.push('/items')
    }
    this.$store.dispatch('benefits/fetchBenefitDetail', { benefit_id: this.$route.params.id })
  }
})
